import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import Navigate from '@nibfe/mkt-navigate-api';
const { invokeJump } = Navigate;
/** 中间页唤起美团打开目标 MRN 页面URL */
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
export const navigateToDetailPage = (detail, monitorNavigateTo) => {
    const { poiId, shopuuid, hotelchannel } = detail;
    const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}&&hotelchannel=${hotelchannel ?? '-999'}`);
    if (isMeituanAppOrWebview()) {
        invokeJump(`imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}&hotelchannel=${hotelchannel ?? '-999'}`);
    }
    else if (isDianpingAppOrWebview()) {
        // 点评app
        invokeJump(`dianping://shopinfo?shopuuid=${shopuuid}&=&hotelchannel=${hotelchannel ?? '-999'}`);
    }
    else if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                // 美团小程序
                monitorNavigateTo({
                    url: `/hotel/pages/poi/pages/index/index?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.mtHotelMinaWebview:
                // 美团酒店小程序
                monitorNavigateTo({
                    url: `/pages/poi/pages/index/index?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.dpMinaWebview:
                // 点评小程序
                const url = `/packages/hotel/pages/poi/pages/index/index?shopId=${poiId}&shopUuid=${shopuuid}`;
                monitorNavigateTo({
                    url,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            default:
                monitorNavigateTo({
                    url: envokePoiDetailLink
                });
                break;
        }
    }
    else {
        monitorNavigateTo({
            url: envokePoiDetailLink
        });
    }
};
export async function navigateToPoiList(params = {}) {
    let pageEnv = getPageEnvironment();
    // 将参数转换为 URL 查询字符串
    const queryString = Object.entries(params).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    navigateTo({
        url: URL_MAP[pageEnv] + queryString,
        _web: {
            miniProgramNative: true
        },
        _meituan: {
            enableElinkLog: true
        }
    });
}
;
// 环境判断逻辑
function getPageEnvironment() {
    if (isMeituanAppOrWebview())
        return 'MT';
    if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                return 'MT_MINA';
            case PlatformType.mtHotelMinaWebview:
                return 'HOTEL_MINA';
            case PlatformType.dpMinaWebview:
                return 'DP_MINA';
            default:
                return 'DEFAULT';
        }
    }
    if (isDianpingAppOrWebview())
        return 'DP';
    return 'DEFAULT';
}
const URL_MAP = {
    MT: 'imeituan://www.meituan.com/hotel/list?mrn_biz=hotel&mrn_entry=rn-hotel-mainlist&mrn_component=hotel-mainlist&',
    DP: 'dianping://hotelsearchresult?mrn_biz=hotel&mrn_entry=rn-hotel-poilist&mrn_component=hotel-poilist&',
    HOTEL_MINA: '/pages/list/index?',
    MT_MINA: '/hotel/pages/list/index?',
    DP_MINA: '/packages/hotel/pages/list/index?',
    DEFAULT: convertLinkToAppMiddleOpenLink("imeituan://www.meituan.com/hotel/list?mrn_biz=hotel&mrn_entry=rn-hotel-mainlist&mrn_component=hotel-mainlist&")
};
